module.exports = __webpack_public_path__ + "img/astral_19.0a37690f.svg";